export {default} from './InterventionsCard.container';
